<app-patient-detail *ngIf="popupData.patientId" [popupData]="popupData" (closePopup)="closePopup($event)"></app-patient-detail>